import React from 'react';
import { motion } from 'framer-motion';
import { volumes } from '../data/content';
export function VolumesSection() {
  return <section className="w-full bg-ivory px-5 py-12 sm:py-20" data-id="element-257" data-mp="3utm4aq96wfw5">
      <div className="mx-auto max-w-5xl" data-id="element-258" data-mp="cp0y69x9sw7c">
        <div className="mx-auto max-w-2xl text-center" data-id="element-259" data-mp="cnzejh26v1e0">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-navy sm:text-4xl" data-id="element-260" data-mp="7owkernqyfkt">
            5 printable volumes
          </h2>
          <p className="mt-3 text-sm text-navy/70 sm:text-base" data-id="element-261" data-mp="3g5hi3caxhm8m">
            120 self-contained, one-page build cards—organized by the kind of thing kids want to
            make.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:gap-6 md:grid-cols-2" data-id="element-262" data-mp="3px43u2kw73pm">
          {volumes.map((volume, i) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.45,
          delay: i % 2 * 0.08
        }} className="flex gap-4 rounded-2xl border border-blue/15 bg-white p-5 shadow-sm shadow-navy/5 sm:gap-6 sm:p-7" data-id="element-263" data-mp="3l2hojobowr09" data-mpi={i}>
              <div className="flex min-w-0 flex-1 flex-col" data-id="element-264" data-mp="2j5k2hkhevmjo">
                <span className="font-serif-display text-3xl font-bold leading-none text-blue sm:text-4xl" data-id="element-265" data-mp="2j63hasbrluth">
                  {volume.number}
                </span>
                <h3 className="mt-3 text-base font-bold leading-snug text-navy sm:text-lg" data-id="element-266" data-mp="1qho5sfrudumw">
                  {volume.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-navy/70" data-id="element-267" data-mp="1vhkcimrxc065">
                  {volume.description}
                </p>
                <span className="mt-5 inline-block w-fit rounded-full bg-blueprint px-3 py-1 text-xs font-semibold text-blue-deep" data-id="element-268" data-mp="24gnv7pn6idk4">
                  {volume.tag}
                </span>
              </div>
              <div className="shrink-0 self-start rounded-xl bg-blueprint p-1.5" data-id="element-269" data-mp="3fusz6ine6nfg">
                <img src={volume.coverImage} alt={`Printable build cards from Volume ${volume.number}: ${volume.title}`} loading="lazy" className="block h-[110px] w-[110px] rounded-lg object-cover sm:h-[150px] sm:w-[150px]" data-id="element-270" data-mp="1gqb488tni3vr" />
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}